import { createSlice } from '@reduxjs/toolkit';
import colors from 'assets/scss/_themes-vars.module.scss';

const initialState = {
  list: [],
  storeList: [],
  pieChart: [],
  date: [],
  menuFilterType: [],
  menuFilterTypeChart: [],
  salesMetrics: [],
  newSalesMatrics: [],
  ppcChart: [],
  salesChartV: [],
  pnlData: [],
  storeId: [],
  tagId: [],
  pnlByItemData: [],
  ppcByItemData: [],
  pnlByItemDataExport: [],
  ppcCategoryData: [],
  groupByProductData: [],
  groupByPPCData: [],
  groupBySalesData: [],
  productVariantData: [],
  salesByBrandData: [],
  pnlDataAccoutGraphData: [],
  graphColors: [
    colors.metricA,
    colors.metricB,
    colors.metricC,
    colors.metricD,
    colors.metricE,
    colors.metricF,
    colors.metricG,
    colors.metricH,
    colors.metricI,
    colors.metricJ,
    colors.metricK,
    colors.metricL,
    colors.metricM,
    colors.metricN,
    colors.metricO
  ],
  itemLevelGraphData: [],
  graphColorsItemLevel: [
    colors.metricP,
    colors.metricQ,
    colors.metricR,
    colors.metricS,
    colors.metricT,
    colors.metricU,
    colors.metricV,
    colors.metricW,
    "#e3c6ff",
    "#72849d",
    "#9c8ec1",
    "#83846e",
    "#c57465",
    "#aaaaaa",
    "#c3b8a5"
  ],
  selectedStoreIds: [],
  childData: [],
  byItemTotal: {},
  byCategoryTotal: {},
  byGroupyTotal: {},
  keywordHistoryData: [],
  changeDayFilter: null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardData: (state, action) => ({
      ...state,
      list: action.payload
    }),
    setDashboardPieChartData: (state, action) => ({
      ...state,
      pieChart: action.payload
    }),
    setSalesDashboardData: (state, action) => ({
      ...state,
      ppcChart: action.payload
    }),
    setSalesVDashboardData: (state, action) => ({
      ...state,
      salesChartV: action.payload
    }),
    setPnlDashboardData: (state, action) => ({
      ...state,
      pnlData: action.payload
    }),
    setPnlByItemData: (state, action) => ({
      ...state,
      pnlByItemData: action.payload
    }),
    setPpcProductCategory: (state, action) => ({
      ...state,
      ppcCategoryData: action.payload
    }),
    setGroupByProduct: (state, action) => ({
      ...state,
      groupByProductData: action.payload
    }),
    setGroupByPPC: (state, action) => ({
      ...state,
      groupByPPCData: action.payload
    }),
    setGroupBySales: (state, action) => ({
      ...state,
      groupBySalesData: action.payload
    }),
    setProductVariant: (state, action) => ({
      ...state,
      productVariantData: action.payload
    }),
    setSalesByBrandData: (state, action) => ({
      ...state,
      salesByBrandData: action.payload
    }),
    setPpcByItemData: (state, action) => ({
      ...state,
      ppcByItemData: action.payload
    }),
    setDashboardStoreData: (state, action) => ({
      ...state,
      storeList: action.payload
    }),
    setDashboardDateRange: (state, action) => ({
      ...state,
      date: action.payload
    }),
    setmenuFilterType: (state, action) => ({
      ...state,
      menuFilterType: action.payload
    }),
    setPnlByItemExport: (state, action) => ({
      ...state,
      pnlByItemDataExport: action.payload
    }),
    setmenuFilterTypeChart: (state, action) => ({
      ...state,
      menuFilterTypeChart: action.payload
    }),
    setSalesMetricsChart: (state, action) => ({
      ...state,
      salesMetrics: action.payload
    }),
    setNewSalesMatrics: (state, action) => ({
      ...state,
      newSalesMatrics: action.payload
    }),
    setStoreIdChart: (state, action) => ({
      ...state,
      storeId: action.payload
    }),
    setTagId: (state, action) => ({
      ...state,
      tagId: action.payload
    }),
    setPnlDataAccoutGraphData: (state, action) => ({
      ...state,
      pnlDataAccoutGraphData: action.payload
    }),
    setItemLevelGraphData: (state, action) => ({
      ...state,
      itemLevelGraphData: action.payload
    }),
    setSelectedStoreIds: (state, action) => ({
      ...state,
      selectedStoreIds: action.payload
    }),
    setChildData: (state, action) => ({
      ...state,
      childData: action.payload
    }),
    setByItemTotal: (state, action) => ({
      ...state,
      byItemTotal: action.payload
    }),
    setByCategoryTotal: (state, action) => ({
      ...state,
      byCategoryTotal: action.payload
    }),
    setByGroupTotal: (state, action) => ({
      ...state,
      byGroupTotal: action.payload
    }),
    setByParentTotal: (state, action) => ({
      ...state,
      byParentTotal: action.payload
    }),
    setKeywordHistoryData: (state, action) => ({
      ...state,
      keywordHistoryData: action.payload
    }),
    setChangeDayFilter: (state, action) => ({
      ...state,
      changeDayFilter: action.payload
    })
  }
});

export const {
  setDashboardData,
  setDashboardStoreData,
  setDashboardPieChartData,
  setSalesDashboardData,
  setSalesByBrandData,
  setSalesVDashboardData,
  setPnlDashboardData,
  setPpcByItemData,
  setPnlByItemData,
  setPpcProductCategory,
  setGroupByProduct,
  setGroupByPPC,
  setGroupBySales,
  setProductVariant,
  setDashboardDateRange,
  setPnlByItemExport,
  setmenuFilterType,
  setmenuFilterTypeChart,
  setSalesMetricsChart,
  setNewSalesMatrics,
  setStoreIdChart,
  setTagId,
  setPnlDataAccoutGraphData,
  setItemLevelGraphData,
  setSelectedStoreIds,
  setChildData,
  setByItemTotal,
  setByCategoryTotal,
  setByGroupTotal,
  setByParentTotal,
  setKeywordHistoryData,
  setChangeDayFilter
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
